import React, { useState, useEffect } from 'react';

export interface UseAnnouncementResult {
  announce: (message: string) => void;
  AnnouncementRegion: () => React.JSX.Element;
}

/**
 * Hook for making screen reader announcements
 * Provides an ARIA live region component and announce function
 */
export function useAnnouncement(): UseAnnouncementResult {
  const [announcement, setAnnouncement] = useState('');
  
  useEffect(() => {
    if (announcement) {
      // Clear announcement after delay to allow multiple announcements
      const timer = setTimeout(() => setAnnouncement(''), 1000);
      return () => clearTimeout(timer);
    }
  }, [announcement]);
  
  const announce = (message: string) => {
    // Clear any existing announcement first to ensure re-announcement
    setAnnouncement('');
    // Use setTimeout to ensure state change is detected
    setTimeout(() => setAnnouncement(message), 50);
  };
  
  const AnnouncementRegion = () => (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className="sr-only"
      aria-relevant="additions text"
    >
      {announcement}
    </div>
  );
  
  return {
    announce,
    AnnouncementRegion,
  };
}